const MAGIC_LINK_ACTION = 'pifster_login_gate_magic_link_request';
const ADMIN_POST_ACTION_URL = '/wp-admin/admin-post.php';

function appendHiddenInput(
  form: HTMLFormElement,
  name: string,
  value: string,
): HTMLInputElement {
  const ownerDocument = form.ownerDocument;
  if (!ownerDocument) {
    throw new Error('[register-toggle] Phantom submission form is missing its owner document.');
  }

  const input = ownerDocument.createElement('input');
  input.type = 'hidden';
  input.name = name;
  input.value = value;
  form.appendChild(input);
  return input;
}

/**
 * Submit a fresh phantom form so the login request bypasses Breakdance AJAX handlers.
 */
export function submitPhantomMagicLinkForm(
  email: string,
  token: string,
  redirectUrl: string,
  nonce: string,
): void {
  const phantomForm = document.createElement('form');
  phantomForm.method = 'POST';
  phantomForm.action = ADMIN_POST_ACTION_URL;
  phantomForm.style.display = 'none';

  appendHiddenInput(phantomForm, 'action', MAGIC_LINK_ACTION);
  appendHiddenInput(phantomForm, 'email', email);
  appendHiddenInput(phantomForm, '_pifster_nonce', nonce);
  appendHiddenInput(phantomForm, 'redirect_to', redirectUrl);
  appendHiddenInput(phantomForm, 'turnstile_token', token);

  document.body.appendChild(phantomForm);
  phantomForm.submit();
}
